import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatAutocomplete } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Data } from './services/data';
import { Messenger } from './services/messenger';
import { WeightCalculator } from './weight-set-weight-calculator';
var WeightSetForm = /** @class */ (function () {
    function WeightSetForm(builder, data, router, route, msg, dialog) {
        this.builder = builder;
        this.data = data;
        this.router = router;
        this.route = route;
        this.msg = msg;
        this.dialog = dialog;
        this.weightSet = this.builder.group({
            name: ['', Validators.required],
            weight: ['0', Validators.min(2.5)],
            reps: ['10', Validators.min(1)],
            when: [moment()
                    .hour(0)
                    .minute(0)
                    .second(0)
                    .millisecond(0).toDate(), Validators.required],
            repeated: ['1', Validators.min(1)],
        });
        this.id = null;
        this.bodyWeight = 0;
        this.name = '';
        this.weight = 0;
        this.reps = 0;
        this.when = moment();
        this.repeated = 1;
    }
    WeightSetForm.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setupSearch();
                        _a = this;
                        return [4 /*yield*/, this.data.getLastWeight()];
                    case 1:
                        _a.bodyWeight = _b.sent();
                        this.route.paramMap.subscribe(function (map) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.id = map.get('id');
                                        this.weightSet.valueChanges.subscribe(function (change) {
                                            _this.name = change.name;
                                            _this.weight = change.weight;
                                            _this.reps = change.reps;
                                            _this.when = moment(change.when)
                                                .hour(0)
                                                .minute(0)
                                                .second(0)
                                                .millisecond(0);
                                            _this.repeated = change.repeated;
                                        });
                                        if (!!!this.id) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.initializeWithId(this.id)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    WeightSetForm.prototype.setupSearch = function () {
        var _this = this;
        var name = this.weightSet.get('name');
        this.recommendedSets = name.valueChanges.pipe(debounceTime(300), switchMap(function (n, i) { return _this.getRecommendations(n); }));
        this.autoComplete.optionSelected.subscribe(this.handleAutoSelection.bind(this));
    };
    WeightSetForm.prototype.handleAutoSelection = function (ev) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var set;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.mostRecentFor(ev.option.value)];
                    case 1:
                        set = _a.sent();
                        this.weightSet.setValue({
                            name: set.name,
                            weight: set.weight,
                            reps: set.reps,
                            when: this.when,
                            repeated: this.repeated,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WeightSetForm.prototype.getRecommendations = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.searchDistinctExerciseNames(name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WeightSetForm.prototype.initializeWithId = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var set;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.getWeightSet(id)];
                    case 1:
                        set = _a.sent();
                        this.weightSet.setValue({
                            name: set.name,
                            weight: set.weight,
                            reps: set.reps,
                            when: set.when.hour(0)
                                .minute(0)
                                .second(0)
                                .millisecond(0),
                            repeated: '1',
                        }, { emitEvent: true, onlySelf: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    WeightSetForm.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var set, arr, i, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        set = {
                            name: this.name,
                            weight: this.weight,
                            reps: this.reps,
                            when: this.when.hour(0)
                                .minute(0)
                                .second(0)
                                .millisecond(0),
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!!!this.id) return [3 /*break*/, 3];
                        set.id = this.id;
                        return [4 /*yield*/, this.data.updateWeightSet(set)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        arr = [];
                        for (i = 0; i < this.repeated; i++) {
                            arr.push(Object.assign({}, set));
                        }
                        return [4 /*yield*/, this.data.addWeightSets(arr)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        return [2 /*return*/, this.msg.send("Unable to save new weight set " + e_1.message, true)];
                    case 7:
                        this.msg.send('Successfully saved new weight set', false);
                        this.router.navigate(['']);
                        return [2 /*return*/];
                }
            });
        });
    };
    WeightSetForm.prototype.calculateWeight = function () {
        var _this = this;
        var dia = this.dialog.open(WeightCalculator, {
            data: {
                bodyWeight: this.bodyWeight
            }
        });
        dia.afterClosed().subscribe(function (result) {
            var v = _this.weightSet.get('weight').value;
            switch (result.type) {
                case 'barbell':
                    v = (result.side * 2) + result.barbell;
                    break;
                case 'dumbbell':
                    v = result.hand * 2;
                    break;
                case 'bodyWeight':
                    v = result.weight;
                    break;
            }
            _this.weightSet.setValue({
                name: _this.name,
                weight: v,
                reps: _this.reps,
                when: _this.when,
                repeated: _this.repeated,
            }, { emitEvent: true, onlySelf: true });
        });
    };
    return WeightSetForm;
}());
export { WeightSetForm };
